import React, { useState } from "react";
import "../Management/SubscribeService.css";
import { Link } from "react-router-dom";

export default function SubscribeService() {
  const [formData, setFormData] = useState({
    companyName: "",
    firstName: "",
    lastName: "",
    email: "",
    phone: "+1",
    countryCode: "+1",
    country: "USA",
    address: "",
    city: "",
    state: "",
    postalCode: "",
    isPurchasingForCompany: false,
  });

  // Country code mapping
  const countryCodeMap = {
    USA: "+1",
    India: "+91",
    UK: "+44",
    Canada: "+1",
    Australia: "+61",
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleCountryChange = (e) => {
    const selectedCountry = e.target.value;
    const newCountryCode = countryCodeMap[selectedCountry];

    setFormData((prev) => ({
      ...prev,
      country: selectedCountry,
      countryCode: newCountryCode,
      phone: newCountryCode, // Reset phone to show new country code
    }));
  };

  // Phone number formatting function
  const formatPhoneNumber = (value, countryCode) => {
    // Remove country code and all non-numeric characters from input
    let cleanValue = value.replace(countryCode, "").replace(/\D/g, "");

    // Prevent infinite length
    if (cleanValue.length > 10) {
      cleanValue = cleanValue.slice(0, 10);
    }

    let formattedNumber = countryCode;

    if (cleanValue.length > 0) {
      switch (countryCode) {
        case "+1": // USA/Canada format: +1 (xxx) xxx-xxxx
          if (cleanValue.length >= 6) {
            formattedNumber = `${countryCode} (${cleanValue.slice(
              0,
              3
            )}) ${cleanValue.slice(3, 6)}-${cleanValue.slice(6)}`;
          } else if (cleanValue.length >= 3) {
            formattedNumber = `${countryCode} (${cleanValue.slice(
              0,
              3
            )}) ${cleanValue.slice(3)}`;
          } else {
            formattedNumber = `${countryCode} (${cleanValue}`;
          }
          break;

        case "+91": // India format: +91 (xxxxx) xxxxx
          if (cleanValue.length >= 5) {
            formattedNumber = `${countryCode} (${cleanValue.slice(
              0,
              5
            )}) ${cleanValue.slice(5)}`;
          } else {
            formattedNumber = `${countryCode} (${cleanValue}`;
          }
          break;

        case "+44": // UK format: +44 (xxxx) xxx-xxx
          if (cleanValue.length >= 7) {
            formattedNumber = `${countryCode} (${cleanValue.slice(
              0,
              4
            )}) ${cleanValue.slice(4, 7)}-${cleanValue.slice(7)}`;
          } else if (cleanValue.length >= 4) {
            formattedNumber = `${countryCode} (${cleanValue.slice(
              0,
              4
            )}) ${cleanValue.slice(4)}`;
          } else {
            formattedNumber = `${countryCode} (${cleanValue}`;
          }
          break;

        case "+61": // Australia format: +61 (xxx) xxx-xxx
          if (cleanValue.length >= 6) {
            formattedNumber = `${countryCode} (${cleanValue.slice(
              0,
              3
            )}) ${cleanValue.slice(3, 6)}-${cleanValue.slice(6)}`;
          } else if (cleanValue.length >= 3) {
            formattedNumber = `${countryCode} (${cleanValue.slice(
              0,
              3
            )}) ${cleanValue.slice(3)}`;
          } else {
            formattedNumber = `${countryCode} (${cleanValue}`;
          }
          break;

        default:
          formattedNumber = `${countryCode} ${cleanValue}`;
      }
    }

    return formattedNumber;
  };

  const handlePhoneChange = (e) => {
    const inputValue = e.target.value;

    // Only format if the input starts with the country code
    if (inputValue.startsWith(formData.countryCode)) {
      const formattedPhone = formatPhoneNumber(
        inputValue,
        formData.countryCode
      );

      setFormData((prev) => ({
        ...prev,
        phone: formattedPhone,
      }));
    } else {
      // If user deletes everything, reset to country code
      if (inputValue === "") {
        setFormData((prev) => ({
          ...prev,
          phone: formData.countryCode,
        }));
      }
    }
  };

  const handlePhoneKeyDown = (e) => {
    // Prevent user from deleting the country code
    const currentValue = e.target.value;
    const countryCode = formData.countryCode;

    if (e.key === "Backspace" && currentValue === countryCode) {
      e.preventDefault();
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
    // Handle form submission logic here
  };

  return (
    <>
      <div className="subscribe-service-page">
        <div className="subscribe-container">
          <form className="subscribe-form" onSubmit={handleSubmit}>
            {/* Company Name Section */}
            <div className="form-section">
              <label className="form-label">Company Name</label>
              <input
                type="text"
                name="companyName"
                value={formData.companyName}
                onChange={handleInputChange}
                className="form-input full-width"
                placeholder=""
              />
              <p className="form-hint">
                Write it exactly how you want us to mention it in your content.
              </p>
            </div>

            {/* Name Section */}
            <div className="form-section">
              <label className="form-label">Name</label>
              <div className="name-row">
                <div className="name-field">
                  <input
                    type="text"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleInputChange}
                    className="form-input row-input"
                    placeholder=""
                  />
                  <label className="field-label">First name</label>
                </div>
                <div className="name-field">
                  <input
                    type="text"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleInputChange}
                    className="form-input row-input"
                    placeholder=""
                  />
                  <label className="field-label">Last name</label>
                </div>
              </div>
            </div>

            {/* Email Section */}
            <div className="form-section">
              <label className="form-label">Email</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                className="form-input full-width"
                placeholder=""
              />
              <p className="form-hint">
                Already have an account?{" "}
                <a href="/login" className="sign-in-link">
                  Sign in here.
                </a>
              </p>
            </div>

            {/* Phone Section */}
            <div className="form-section">
              <label className="form-label">Phone</label>
              <div className="phone-row">
                <div className="phone-input-container">
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handlePhoneChange}
                    onKeyDown={handlePhoneKeyDown}
                    className="form-input phone-input"
                    placeholder={`${formData.countryCode} (xxx) xxx-xxxx`}
                    autoComplete="tel"
                  />
                </div>
                <div className="country-select">
                  <select
                    name="country"
                    value={formData.country}
                    onChange={handleCountryChange}
                    className="form-select"
                  >
                    <option value="USA">USA (+1)</option>
                    <option value="India">India (+91)</option>
                    <option value="UK">UK (+44)</option>
                    <option value="Canada">Canada (+1)</option>
                    <option value="Australia">Australia (+61)</option>
                  </select>
                </div>
              </div>
            </div>

            {/* Billing Address Section */}
            <div className="form-section">
              <label className="form-label">Billing address</label>

              <div className="address-row">
                <div className="address-field">
                  <input
                    type="text"
                    name="address"
                    value={formData.address}
                    onChange={handleInputChange}
                    className="form-input"
                    placeholder=""
                  />
                  <label className="field-label">Address</label>
                </div>
                <div className="city-field">
                  <input
                    type="text"
                    name="city"
                    value={formData.city}
                    onChange={handleInputChange}
                    className="form-input"
                    placeholder=""
                  />
                  <label className="field-label">City</label>
                </div>
              </div>

              <div className="location-row">
                <div className="country-field">
                  <select
                    name="billingCountry"
                    className="form-select"
                    defaultValue="USA"
                  >
                    <option value="USA">USA</option>
                    <option value="India">India</option>
                    <option value="UK">UK</option>
                    <option value="Canada">Canada</option>
                    <option value="Australia">Australia</option>
                  </select>
                  <label className="field-label">Country</label>
                </div>
                <div className="state-field">
                  <input
                    type="text"
                    name="state"
                    value={formData.state}
                    onChange={handleInputChange}
                    className="form-input "
                    placeholder=""
                  />
                  <label className="field-label">
                    State / Province / Region
                  </label>
                </div>
                <div className="postal-field">
                  <input
                    type="text"
                    name="postalCode"
                    value={formData.postalCode}
                    onChange={handleInputChange}
                    className="form-input"
                    placeholder=""
                  />
                  <label className="field-label">Postal / Zip Code</label>
                </div>
              </div>
            </div>

            {/* Checkbox Section */}
            <div className="form-section">
              <label className="checkbox-container">
                <input
                  type="checkbox"
                  name="isPurchasingForCompany"
                  checked={formData.isPurchasingForCompany}
                  onChange={handleInputChange}
                  className="form-checkbox"
                />
                <span className="checkmark"></span>
                I'm purchasing for a company
              </label>
            </div>

            {/* Submit Button */}
            <div className="form-section">
              <Link to="/checkout">
                <button type="submit" className="submit-button">
                  Continue to Payment
                </button>
              </Link>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
